/* global global */

const requiredAppConfig = require("./requiredAppConfig");

/**
 * Take the list of configuration parameters from the index of this submodule,,
 * read them from `window`,
 * and export them as an object.
 */
module.exports = requiredAppConfig.reduce(
  (prev, curr) => {
    // Use global (window[ENV]) value if configured at runtime
    if (typeof global[curr] !== "undefined") {
      return {
        ...prev,
        [curr]: global[curr],
      };
    }
    // In Jest, window.bundleConfiguration is faked onto JSDOM in jest.setup.js.
    // In WDS, window.bundleConfiguration is added to HTMLWebpackPlugin's generated output.
    // In Express, window.bundleConfiguration is added to SSR-ed HTML by our custom templater.
    if (
      typeof global.bundleConfiguration !== "undefined" &&
      curr in global.bundleConfiguration
    ) {
      return {
        ...prev,
        [curr]: global.bundleConfiguration[curr],
      };
    } else {
      throw new Error(`${curr} was not provided to the webpack bundle.`);
    }
  },
  { requiredAppConfig }
);
